<div class="l-container" tg>
    <section *ngIf="userInitialised" class="h-spacing-page-bottom">
        <tm-notifications></tm-notifications>
        <property-header></property-header>
        <router-outlet></router-outlet>
        <tg-teleport-outlet (change)="updateIsModalActive($event)" name="modal">
        </tg-teleport-outlet>
    </section>
    <section *ngIf="!userInitialised">
        <tg-info-box *ngIf="error" tgStyle="danger">
            <tg-icon alt="Error" name="basic-warning-framed"> </tg-icon>
            There is an error: {{ error }}
        </tg-info-box>
    </section>
</div>
